import type { BaseCustomersGroup } from '@futureecom/futureecom-js/dist/services/customer-service'

export default (groups: BaseCustomersGroup[]): boolean => groups.map((item) => item.code).includes('b2b')
